import styled from "styled-components/macro";

export const Container = styled.div`
  display: flex;
  padding-top: 50px;
  text-align: center;
  max-width: 1280px;
  padding: 2em;
  padding-top: 1em;
  margin: auto;
  color: var(--grey-0);

  .categories {
    flex: 1;
    align-self: flex-start;
    position: sticky;
    top: 0; /* not stick without this? */
    width: 125px;
    min-width: 205px;
    max-width: 205px;
    padding-top: 3em;
    margin-right: 20px;

    .back-button {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 12px;
      margin-bottom: 16px;
      color: var(--grey-1);
      text-decoration: none;
      font-family: "Inter", sans-serif;
      font-size: 14px;
      font-weight: 500;
      border-radius: 6px;
      transition: background-color 0.15s, color 0.15s;

      &:hover {
        background-color: var(--container-color);
        color: var(--grey-0);
      }

      img {
        width: 16px;
        height: 16px;
        opacity: 0.7;
      }
    }

    h3 {
      margin-bottom: 10px;
      margin-left: 3px;
    }

    ul {
      font-family: "Inter", sans-serif;
      font-size: 14px;
      line-height: 100%;
      font-weight: 500;

      li {
        display: block;
        margin-bottom: 5px;
        text-align: left;

        a {
          display: flex;
          align-items: center;
          padding: 2px 0 2px 15px;
          transition: opacity 300ms;

          border-left: 4px solid transparent;
          color: var(--grey-0);
          opacity: 0.6;
          &:hover {
            opacity: 0.9;
          }
          .vertical-selected-indicator {
            background-color: transparent;
            width: 4px;
            border-radius: 3px;
            margin-right: 10px;
            height: 28px;
            display: block;
          }
          &.selected {
            color: var(--primary-cta);
            opacity: 1;
            .vertical-selected-indicator {
              background-color: var(--primary-cta);
            }
          }
        }
      }
    }
  }

  .header {
    display: flex;
    justify-content: space-between;
    margin: 36px auto 24px auto;
    align-items: center;

    max-width: 978px;

    h1 {
      text-align: left;
      margin: 0px;

      svg {
        width: 30px;
        position: relative;
        top: 5px;
        path {
          fill: var(--grey-0);
        }
      }

      span {
        font-size: 14px;
        color: var(--grey-1);
      }
    }
    a {
      margin: 0;
      button {
        font-family: "Inter", sans-serif;
        // margin: 0 !important;
        padding: 10px 16px 10px 12px !important;
        border-radius: 10px !important;
        background: var(--primary-cta);
        font-weight: 500;
        color: #fff;
        margin-left: 20px;
        border: 0;
        font-size: 16px;
      }
    }
  }
  .plugin-list-container {
    min-width: 992px;
  }
  .main-container {
    text-align: left;
    display: flex;
    max-width: 1288px;
    margin: auto;
    gap: 45px;

    .plugins-container {
      .spinner-container {
        display: flex;
        justify-content: center;
      }
    }
  }
  .search-container {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .search {
    border-radius: 30px;
    background: var(--container-color);
    padding: 10px;
    display: flex;
    flex-direction: row;
    // width: 150px;

    input {
      font-size: 16px;
      border: 0;
      background: transparent;
      color: var(--grey-0);
      width: 125px;
      ::placeholder {
        color: var(--grey-1);
      }
    }
  }

  .search-header {
    margin: auto;
    text-align: center;
  }

  .sort-toggle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    gap: 5px;
    font-family: "Inter", sans-serif;
    position: absolute;
    font-weight: 500;
    left: 50%;
    transform: translateX(-50%);

    a {
      /* color: var(--grey-0); */
      text-decoration: none;
      padding: 10px;
      opacity: 0.6;
      color: var(--grey-0);
      transition: background-color 0.3s ease;
      text-align: center;
      font-size: 14px;
      display: flex;
      flex-direction: column;
      transition: opacity 300ms;
      .horizontal-selected-indicator {
        height: 4px;
        width: 100%;
        background-color: transparent;
        margin-top: 8px;
        border-radius: 3px;
      }

      &:hover {
        opacity: 0.9;
      }

      &.selected {
        opacity: 1;
        color: var(--primary-cta);
        .horizontal-selected-indicator {
          background-color: var(--primary-cta);
        }
      }
    }
  }

  .loading {
    font-size: 3em;
    margin: auto;
    text-align: center;
  }

  .none {
    text-align: center;
    display: block;
  }

  .plugins {
    gap: 15px;
    margin: 20px auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
    gap: 24px;
    width: 100%;
    max-width: 978px;
    min-width: 800px;
  }

  .featured {
    background: var(--container-color);
    border-radius: 24px;
    position: relative;
    /* right: 25px; */
    /* left: -50px; */
    /* width: calc(100% + 100px); */
    padding: 25px 25px 8px 25px;
    width: 100%;
    max-width: 978px;
    margin: 20px auto;

    h3 {
      display: block;
    }
  }

  @media only screen and (max-width: 948px) {
    .plugins {
      max-width: 624px;
    }
  }
`;
